module.exports = __webpack_public_path__ + "media/images/logos/rumble-logo-e23b0f0b66387089a5c2ca44bcec3209.svg";